import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  INICIA_ALUNO,
  SALVA_ALUNO,
  ATUALIZA_ALUNO,
  BUSCA_ALUNO_EDICAO,
  REMOVE_ALUNO,
  LISTA_ALUNO,
  LISTA_ESCOLAS_ALUNO,
  LISTA_CURSOS_POR_ESCOLA_ALUNO,
  LISTA_SERIES_POR_CURSO_ALUNO,
  LISTA_TURMAS_POR_SERIE_ALUNO
} from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import { showAuthMessage } from "actions/Aluno";
import {
  salvaAlunoSucesso,
  removeAlunoSucesso,
  inicioAlunoSucesso,
  buscaAlunoEdicaoSucesso,
  listaAlunoSucesso,
  listaEscolasAlunoSucesso,
  listaCursosPorEscolaAlunoSucesso,
  listaSeriesPorCursoAlunoSucesso,
  listaTurmasPorSerieAlunoSucesso
} from "actions/Aluno";

/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

const getAlunos = async () =>
  await requisicaoApi.get('/alunos')
    .then(resposta => resposta)
    .catch(error => error);

const getAlunoEdicao = async (id) =>
  await requisicaoApi.get('/alunos/' + id)
    .then(resposta => resposta)
    .catch(error => error);

const getTodosCursos = async () =>
  await requisicaoApi.get('/cursos')
    .then(resposta => resposta)
    .catch(error => error);

const getSeriesAll = async () =>
  await requisicaoApi.get('/series')
    .then(resposta => resposta)
    .catch(error => error);

const getTurmasAll = async () =>
  await requisicaoApi.get('/turmas')
    .then(resposta => resposta)
    .catch(error => error);

const normalizeFiltro = (f) => {
  const out = { ...f };
  const toParam = (v) => {
    if (v === undefined || v === null) return undefined;
    const n = Number(v);
    if (isFinite(n)) return n === 0 ? undefined : n;
    return v;
  };
  // Mapeamento para garantir que os parâmetros vão para o backend corretamente
  // conforme esperado pelo controller (geralmente PascalCase ou camelCase dependendo da API,
  // mas aqui seguimos o padrão de Matrícula que envia PascalCase nos params se necessário,
  // ou o axios serializa. Vamos garantir os nomes corretos.)
  out.EscolaId = toParam(f.EscolaId || f.escolaId);
  out.CursoId = toParam(f.CursoId || f.cursoId);
  out.SerieId = toParam(f.SerieId || f.serieId);
  out.TurmaId = toParam(f.TurmaId || f.turmaId);
  out.Idade = toParam(f.Idade || f.idade);

  const nome = f.nome || f.Nome || f.Texto || f.Search || undefined;
  if (nome) out.Nome = nome;

  // Parâmetros de paginação e ordenação para o servidor
  out.page = f.page || 1;
  out.per_page = f.perPage || 10;
  out.sort = f.orderBy || undefined;
  out.direction = f.orderDirection || undefined;

  return out;
};

const getListaAluno = async (filtros) =>
  await requisicaoApi.get('/alunos/paginado', { params: normalizeFiltro(filtros || {}) })
    .then(resposta => resposta)
    .catch(error => error);

const getEscolas = async () =>
  await requisicaoApi.get('/escolas')
    .then(resposta => resposta)
    .catch(error => error);

const getCursosDaEscola = async (idEscola) =>
  await requisicaoApi.get(`/escolas/${idEscola}/cursos`)
    .then(resposta => resposta)
    .catch(error => error);

const getSeriesPorCurso = async (cursoId) =>
  await requisicaoApi.get('/series', { params: { CursoId: cursoId } })
    .then(resposta => resposta)
    .catch(error => error);

const getTurmasPorSerieOuCurso = async ({ serieId, cursoId, escolaId }) =>
  await requisicaoApi.get('/turmas', { params: { SerieId: serieId, SeriesId: serieId, CursoId: cursoId, EscolaId: escolaId } })
    .then(resposta => resposta)
    .catch(error => error);

/*#################################################################################################################*/
/* ------------------------------------- Requests do tipo POST, PUT E DELETE --------------------------------------*/

// Suporta tanto JSON quanto FormData. Quando receber FormData, axios define o content-type automaticamente.
const adicionaAlunoRequest = async (alunoOuFormData) => await requisicaoApi.post('/alunos', alunoOuFormData)
  .then(resposta => resposta)
  .catch(error => error);

const atualizaAlunoRequest = async (alunoOuFormData) => {
  const id = (alunoOuFormData && alunoOuFormData.id) || (alunoOuFormData && alunoOuFormData.Id);
  // Quando for FormData, o id pode ter sido anexado como campo. Vamos tentar extrair.
  let idStr = '';
  try {
    if (alunoOuFormData instanceof FormData) {
      const idVal = alunoOuFormData.get('id');
      idStr = String(idVal || '').trim();
    } else {
      idStr = String(id || '').trim();
    }
  } catch (_) { }

  return await requisicaoApi.put('/alunos/' + idStr, alunoOuFormData)
    .then(resposta => resposta)
    .catch(error => error);
}

const deleteAlunoRequest = async (id) =>
  await requisicaoApi.delete('/alunos/' + id)
    .then(resposta => resposta)
    .catch(error => error);

/*#################################################################################################################*/
/* ------------------------------------------ Funções das Sagas ---------------------------------------------------*/

function* fnIniciaAluno() {
  try {
    const retorno = yield call(getAlunos);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(inicioAlunoSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnBuscaAlunoEdicao({ payload }) {
  try {
    const retorno = yield call(getAlunoEdicao, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(buscaAlunoEdicaoSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaAluno({ payload }) {
  try {
    const retorno = yield call(getListaAluno, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(listaAlunoSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaEscolasAluno() {
  try {
    const retorno = yield call(getEscolas);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(listaEscolasAlunoSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaCursosPorEscolaAluno({ payload }) {
  try {
    if (payload === 'ALL' || payload === 0) {
      yield put(listaCursosPorEscolaAlunoSucesso([]));
      return;
    }
    const retorno = yield call(getCursosDaEscola, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(listaCursosPorEscolaAlunoSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaSeriesPorCursoAluno({ payload }) {
  try {
    if (payload === 'ALL' || payload === 0) {
      yield put(listaSeriesPorCursoAlunoSucesso([]));
      return;
    }
    const retorno = yield call(getSeriesPorCurso, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(listaSeriesPorCursoAlunoSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaTurmasPorSerieAluno({ payload }) {
  try {
    const { serieId, cursoId, escolaId } = payload;
    if ((!serieId && !cursoId && !escolaId) || payload === 'ALL') {
      yield put(listaTurmasPorSerieAlunoSucesso([]));
      return;
    }
    const retorno = yield call(getTurmasPorSerieOuCurso, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(listaTurmasPorSerieAlunoSucesso(retorno.data));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnSalvaAluno({ payload }) {
  try {
    const alunoEntrada = payload;
    const isFD = (typeof FormData !== 'undefined') && (alunoEntrada instanceof FormData);
    const normalizeId = (v) => {
      if (v === null || typeof v === 'undefined' || v === '') return undefined;
      const n = parseInt(String(v), 10);
      if (isNaN(n) || n <= 0) return undefined;
      return n;
    };
    let aluno = alunoEntrada;
    if (!isFD) {
      const jaTemResp = Array.isArray(alunoEntrada.responsaveis);
      const respResp = Array.isArray(alunoEntrada.responsaveis) ? alunoEntrada.responsaveis.map(it => ({
        IdPessoaResponsavel: normalizeId(it && it.pessoaVinculada),
        TipoParentesco: (it && it.parentesco) || null,
        TipoRelacao: 'RESPONSAVEL',
        CadastroNoApp: !!(it && ((it.CadastroNoApp !== undefined) ? it.CadastroNoApp : it.cadastroNoApp))
      })).filter(x => typeof x.IdPessoaResponsavel !== 'undefined') : [];
      const respAut = Array.isArray(alunoEntrada.autorizados) ? alunoEntrada.autorizados.map(it => ({
        IdPessoaResponsavel: normalizeId(it && it.pessoaVinculada),
        TipoParentesco: (it && it.parentesco) || null,
        TipoRelacao: 'AUTORIZADO',
        CadastroNoApp: !!(it && ((it.CadastroNoApp !== undefined) ? it.CadastroNoApp : it.cadastroNoApp))
      })).filter(x => typeof x.IdPessoaResponsavel !== 'undefined') : [];
      aluno = {
        ...alunoEntrada,
        responsaveis: jaTemResp ? [...respResp, ...respAut] : [...respResp, ...respAut]
      };
    }
    const request = aluno.id && aluno.id !== 0 ? atualizaAlunoRequest : adicionaAlunoRequest;
    const retorno = yield call(request, aluno);
    if (retorno.message) {
      const status = retorno?.response?.status;
      const data = retorno?.response?.data;
      if (status === 400) {
        let mensagemValidacao = '';
        let inconsistencias = data?.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
          // Ex.: [{ propriedade: 'CodigoInep', mensagem: 'Já existe ...' }]
          mensagemValidacao = inconsistencias[0].mensagem;
        } else if (data && typeof data === 'object') {
          mensagemValidacao = data.mensagem || JSON.stringify(data);
        }
        yield put(showAuthMessage(mensagemValidacao || retorno.message));
      } else {
        yield put(showAuthMessage(JSON.stringify(retorno.message)));
      }
    } else {
      yield put(salvaAlunoSucesso("Cadastro salvo com sucesso!"));
      yield put({ type: LISTA_ALUNO, payload: { nome: '' } });
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnAtualizaAluno({ payload }) {
  try {
    const alunoEntrada = payload;
    const isFD = (typeof FormData !== 'undefined') && (alunoEntrada instanceof FormData);
    const normalizeId = (v) => {
      if (v === null || typeof v === 'undefined' || v === '') return undefined;
      const n = parseInt(String(v), 10);
      if (isNaN(n) || n <= 0) return undefined;
      return n;
    };
    let aluno = alunoEntrada;
    if (!isFD) {
      const jaTemResp = Array.isArray(alunoEntrada.responsaveis);
      const respResp = Array.isArray(alunoEntrada.responsaveis) ? alunoEntrada.responsaveis.map(it => ({
        IdPessoaResponsavel: normalizeId(it && it.pessoaVinculada),
        TipoParentesco: (it && it.parentesco) || null,
        TipoRelacao: 'RESPONSAVEL',
        CadastroNoApp: !!(it && ((it.CadastroNoApp !== undefined) ? it.CadastroNoApp : it.cadastroNoApp))
      })).filter(x => typeof x.IdPessoaResponsavel !== 'undefined') : [];
      const respAut = Array.isArray(alunoEntrada.autorizados) ? alunoEntrada.autorizados.map(it => ({
        IdPessoaResponsavel: normalizeId(it && it.pessoaVinculada),
        TipoParentesco: (it && it.parentesco) || null,
        TipoRelacao: 'AUTORIZADO',
        CadastroNoApp: !!(it && ((it.CadastroNoApp !== undefined) ? it.CadastroNoApp : it.cadastroNoApp))
      })).filter(x => typeof x.IdPessoaResponsavel !== 'undefined') : [];
      aluno = {
        ...alunoEntrada,
        responsaveis: jaTemResp ? [...respResp, ...respAut] : [...respResp, ...respAut]
      };
    }
    const retorno = yield call(atualizaAlunoRequest, aluno);
    if (retorno.message) {
      const status = retorno?.response?.status;
      const data = retorno?.response?.data;
      if (status === 400) {
        let mensagemValidacao = '';
        let inconsistencias = data?.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
          // Ex.: [{ propriedade: 'CodigoInep', mensagem: 'Já existe ...' }]
          mensagemValidacao = inconsistencias[0].mensagem;
        } else if (data && typeof data === 'object') {
          mensagemValidacao = data.mensagem || JSON.stringify(data);
        }
        yield put(showAuthMessage(mensagemValidacao || retorno.message));
      } else {
        yield put(showAuthMessage(JSON.stringify(retorno.message)));
      }
    } else {
      yield put(salvaAlunoSucesso("Cadastro atualizado com sucesso!"));
      yield put({ type: LISTA_ALUNO, payload: { nome: '' } });
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnRemoveAluno({ payload }) {
  try {
    const retorno = yield call(deleteAlunoRequest, payload);

    // Verifica se houve erro de validação (status 400 ou sucesso: false)
    const data = retorno?.response?.data || retorno?.data;

    // Tratamento para quando a API retorna erro 400 com inconsistências
    if (retorno?.response?.status === 400 || (data && data.sucesso === false)) {
      let mensagemErro = '';
      if (Array.isArray(data?.inconsistencias) && data.inconsistencias.length > 0) {
        mensagemErro = data.inconsistencias[0].mensagem;
      } else if (Array.isArray(data?.erros) && data.erros.length > 0) {
        mensagemErro = data.erros[0].mensagem;
      } else {
        mensagemErro = data?.mensagem || 'Erro ao excluir aluno.';
      }
      yield put(showAuthMessage(mensagemErro));
      return;
    }

    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(removeAlunoSucesso("Removido com sucesso!"));
      yield put({ type: LISTA_ALUNO, payload: { nome: '' } });
    }
  } catch (error) {
    // Tenta extrair mensagem amigável de erro se disponível
    const msg = error?.response?.data?.mensagem ||
      (error?.response?.data?.inconsistencias?.[0]?.mensagem) ||
      JSON.stringify(error);
    yield put(showAuthMessage(msg));
  }
}

/*#################################################################################################################*/
/* -------------------------------------- Exportação das Sagas ----------------------------------------------------*/

export function* iniciaAcoesAluno() {
  yield takeEvery(INICIA_ALUNO, fnIniciaAluno);
}

export function* salvaAluno() {
  yield takeEvery(SALVA_ALUNO, fnSalvaAluno);
}

export function* atualizaAluno() {
  yield takeEvery(ATUALIZA_ALUNO, fnAtualizaAluno);
}

export function* buscaAlunoEdicao() {
  yield takeEvery(BUSCA_ALUNO_EDICAO, fnBuscaAlunoEdicao);
}

export function* removeAluno() {
  yield takeEvery(REMOVE_ALUNO, fnRemoveAluno);
}

export function* listaAluno() {
  yield takeEvery(LISTA_ALUNO, fnListaAluno);
}

export default function* rootSaga() {
  yield all([
    takeEvery(INICIA_ALUNO, fnIniciaAluno),
    takeEvery(SALVA_ALUNO, fnSalvaAluno),
    takeEvery(ATUALIZA_ALUNO, fnAtualizaAluno),
    takeEvery(BUSCA_ALUNO_EDICAO, fnBuscaAlunoEdicao),
    takeEvery(REMOVE_ALUNO, fnRemoveAluno),
    takeEvery(LISTA_ALUNO, fnListaAluno),
    takeEvery(LISTA_ESCOLAS_ALUNO, fnListaEscolasAluno),
    takeEvery(LISTA_CURSOS_POR_ESCOLA_ALUNO, fnListaCursosPorEscolaAluno),
    takeEvery(LISTA_SERIES_POR_CURSO_ALUNO, fnListaSeriesPorCursoAluno),
    takeEvery(LISTA_TURMAS_POR_SERIE_ALUNO, fnListaTurmasPorSerieAluno)
  ]);
}
